<template>
    <b-container id="header" fluid="lg">
        <b-row class="team-title">
            <b-col style="padding-right: 0;">
                <div class="team-header" style="background-color: #f73051;">
                    <div class="team-name left">{{teams['A']['full']}}</div>
                    <div class="team-scores">
                        <div class="sum-score" v-b-tooltip.hover.left title="Összes gól">{{getStat('A', 'success')}}</div>
                        <div v-if="getStat('A', 'success') !== getHalfTimeGoals('A') || getStat('B', 'success') !== getHalfTimeGoals('B')" class="half-score" v-b-tooltip.hover.left title="1. félidő góljai">{{getHalfTimeGoals('A')}}</div>
                    </div>
                </div>
            </b-col>
            <b-col style="padding-left: 0;">
                <div class="team-header" style="background-color: #1cb568;">
                    <div class="team-scores">
                        <div class="sum-score" v-b-tooltip.hover.right title="Összes gól">{{getStat('B', 'success')}}</div>
                        <div v-if="getStat('A', 'success') !== getHalfTimeGoals('A') || getStat('B', 'success') !== getHalfTimeGoals('B')" class="half-score" v-b-tooltip.hover.right title="1. félidő góljai">{{getHalfTimeGoals('B')}}</div>
                    </div>
                    <div class="team-name right">{{teams['B']['full']}}</div>
                </div>
            </b-col>
        </b-row>
        <div class="logos">
            <div class="team-logo">
                <img v-if="teams['A']['logo']" :src="teams['A']['logo']" :alt="teams['A']['full']" :title="teams['A']['full']">
            </div>
            <div class="match-data" v-if="matchdate || venue || competition">
                <div class="match-time" v-if="matchdate">{{ matchdate }}</div>
                <div class="match-place" v-if="venue">{{ venue }}</div>
                <div class="match-competition" v-if="competition">{{ competition }}</div>
            </div>
            <div class="team-logo">
                <img v-if="teams['B']['logo']" :src="teams['B']['logo']" :alt="teams['B']['full']" :title="teams['B']['full']">
            </div>
        </div>
        <b-row class="icon-stats">
            <b-col class="stat-box">
                <div class="mini-stat" v-b-tooltip.hover.top.html title="Lőtt gólok /<br> Összes lövés">
                    <img src="/icon/goal.svg" alt="Lőtt gólok" title="Lőtt gólok"/>
                    {{getStat('A', 'success') + '/' + getStat('A', 'all')}}
                </div>
                <div class="mini-stat" v-b-tooltip.hover.top.html title="7m-es gólok /<br> Összes 7m-es lövés">
                    <img src="/icon/7-m.svg" alt="7 méteres gólok" title="7 méteres gólok"/>
                    {{getStat('A', 'success', true) + '/' + (getStat('A', 'all', true))}}
                </div>
                <div class="mini-stat" :class="!getStat('A', 'sargalap') ? 'empty' : ''" v-b-tooltip.hover.top title="Sárga lapok">
                    <img src="/icon/yellow-card.svg" alt="Sárga lapok" title="Sárga lapok"/>
                    {{getStat('A', 'sargalap')}}
                </div>
                <div class="mini-stat" :class="!getStat('A', 'kiallitas') ? 'empty' : ''" v-b-tooltip.hover.top title="2 perces kiállítások">
                    <img src="/icon/2-min.svg" alt="Kiállítások" title="Kiállítások"/>
                    {{getStat('A', 'kiallitas')}}
                </div>
                <div class="mini-stat" :class="!getStat('A', 'piroslap') ? 'empty' : ''" v-b-tooltip.hover.top title="Piros lapok">
                    <img src="/icon/red-card.svg" alt="Piros lapok" title="Piros lapok"/>
                    {{getStat('A', 'piroslap')}}
                </div>
                <div class="mini-stat" :class="!getStat('A', 'keklap') ? 'empty' : ''" v-b-tooltip.hover.top title="Kék lapok">
                    <img src="/icon/blue-card.svg" alt="Kék lapok" title="Kék lapok"/>
                    {{getStat('A', 'keklap')}}
                </div>
              <div class="mini-stat" :class="!getStat('A', 'timeOut') ? 'empty' : ''">
                <img
                    v-for="(icon, index) in timeoutIconsA"
                    :key="index"
                    :src="`/icon/${icon.icon}.svg`"
                    :title="icon.tooltip"
                    v-b-tooltip.hover.top
                />
              </div>
            </b-col>
            <b-col class="stat-box">
                <div class="mini-stat" v-b-tooltip.hover.top.html title="Lőtt gólok /<br> Összes lövés">
                    <img src="/icon/goal.svg" alt="Lőtt gólok" title="Lőtt gólok"/>
                    {{getStat('B', 'success') + '/' + getStat('B', 'all')}}
                </div>
                <div class="mini-stat" v-b-tooltip.hover.top.html title="7m-es gólok /<br> Összes 7m-es lövés">
                    <img src="/icon/7-m.svg" alt="7 méteres gólok" title="7 méteres gólok"/>
                    {{getStat('B', 'success', true) + '/' + (getStat('B', 'all', true))}}
                </div>
                <div class="mini-stat" :class="!getStat('B', 'sargalap') ? 'empty' : ''" v-b-tooltip.hover.top title="Sárga lapok">
                    <img src="/icon/yellow-card.svg" alt="Sárga lapok" title="Sárga lapok"/>
                    {{getStat('B', 'sargalap')}}
                </div>
                <div class="mini-stat" :class="!getStat('B', 'kiallitas') ? 'empty' : ''" v-b-tooltip.hover.top title="2 perces kiállítások">
                    <img src="/icon/2-min.svg" alt="Kiállítások" title="Kiállítások"/>
                    {{getStat('B', 'kiallitas')}}
                </div>
                <div class="mini-stat" :class="!getStat('B', 'piroslap') ? 'empty' : ''" v-b-tooltip.hover.top title="Piros lapok">
                    <img src="/icon/red-card.svg" alt="Piros lapok" title="Piros lapok"/>
                    {{getStat('B', 'piroslap')}}
                </div>
                <div class="mini-stat" :class="!getStat('B', 'keklap') ? 'empty' : ''" v-b-tooltip.hover.top title="Kék lapok">
                    <img src="/icon/blue-card.svg" alt="Kék lapok" title="Kék lapok"/>
                    {{getStat('B', 'keklap')}}
                </div>
              <div class="mini-stat" :class="!getStat('B', 'timeOut') ? 'empty' : ''" >
                <img
                    v-for="(icon, index) in timeoutIconsB"
                    :key="index"
                    :src="`/icon/${icon.icon}.svg`"
                    :title="icon.tooltip"
                    v-b-tooltip.hover.top
                />
                <!--<img src="/icon/time.svg" alt="Időkérések" title="Időkérések"/>
                <img src="/icon/time-gray.svg" alt="Időkérések" title="Időkérések"/>
                <img src="/icon/time-red.svg" alt="Időkérések" title="Időkérések"/>
                {{getStat('B', 'timeout')}} / 3-->
              </div>
            </b-col>
        </b-row>
        <b-tabs id="main-nav" @input="changePage" v-model="tabIndex">
            <b-tab v-if="!disabled" title="Jegyzőkönyv" :disabled="disabled"/>
            <b-tab title="Események"/>
            <b-tab title="Játékos statisztikák"/>
            <b-tab title="Mérkőzés statisztikák"/>
        </b-tabs>
    </b-container>
</template>

<script>
    import Stat from '@/Statistics';

    export default {
        name: 'TeremHeader',
        props: {
            id: String,
            szezonid: String,
            teams: Object,
            statistics: Object,
            venue: String,
            matchdate: String,
            competition: String,
            age: String,
            gender: String,
            lastPeriod: String,
            items: Array
        },
        data: function () {
            return {
                tabIndex: 1,
                disabled: true,
                s: Stat,
            };
        },
        created() {
            this.tabIndex = this.$route.meta.tab;

            if(this.disabled) {
                this.tabIndex--;
            }
        },
        computed: {
          timeoutIconsB() {
            return this.timeoutIcons('B')
          },
          timeoutIconsA() {
            return this.timeoutIcons('A')
          },
          getLastEvent()
          {
            if (!this.items || !this.items.length) return null;

            const self = this;
            const maxGameTimeItem = this.items.reduce((maxItem, currentItem) => {
              const currentSeconds = self.convertGameTimeToSeconds(currentItem.gameTime);
              const maxSeconds = self.convertGameTimeToSeconds(maxItem.gameTime);
              return currentSeconds > maxSeconds ? currentItem : maxItem;
            });

            const maxSeconds = this.convertGameTimeToSeconds(maxGameTimeItem.gameTime);

            return maxSeconds >= 3300;
          }
        },
        methods: {
          convertGameTimeToSeconds(gameTime) {
            const [minutes, seconds] = gameTime.split(":").map(Number);
            return minutes * 60 + seconds;
          },
          timeoutIcons(team) {
            const totalTimeouts = this.getStat(team, 'timeout') || 0;
            const timeouts = this.items
                ?.filter(item => item.action === 'timeOut' && item.team === team)
                ?.sort((a, b) => this.convertGameTimeToSeconds(a.gameTime) - this.convertGameTimeToSeconds(b.gameTime)) || [];

            const timeoutDetails = timeouts.map(t => {
              const seconds = this.convertGameTimeToSeconds(t.gameTime);
              return {
                seconds,
                after55: seconds >= 3300,
                tooltip: t.gameTime
              };
            });

            let icons = ['time-gray', 'time-gray', 'time-gray'];
            let tooltips = ['-', '-', '-'];

            const firstHalf = timeoutDetails.filter(t => t.seconds < 1800);
            const secondHalf = timeoutDetails.filter(t => t.seconds >= 1800 && t.seconds < 3600);
            const after55 = timeoutDetails.filter(t => t.after55);

            const fhCount = firstHalf.length;
            const shCount = secondHalf.length;
            const after55Count = after55.length;
            const currentPeriod = parseInt(this.lastPeriod);
            const isAfterMatch = currentPeriod > 3;
            const isAfter55 = this.items?.some(item => this.convertGameTimeToSeconds(item.gameTime) >= 3300);

            if (isAfterMatch) {
              if (totalTimeouts === 0) {
                icons = ['time-red', 'time-red', 'time-red'];
              } else if (totalTimeouts === 1) {
                if (fhCount === 1 && !after55Count) icons = ['time', 'time-red', 'time-red'];
                else if (shCount === 1 && !after55Count) icons = ['time-red', 'time', 'time-red'];
                else if (after55Count === 1) icons = ['time-red', 'time-red', 'time'];
              } else if (totalTimeouts === 2) {
                if (fhCount === 2) icons = ['time', 'time', 'time-red'];
                else if (fhCount === 1 && shCount === 1 && !after55Count) icons = ['time', 'time', 'time-red'];
                else if (fhCount === 1 && after55Count === 1) icons = ['time', 'time-red', 'time'];
                // JAVÍTÁS: ugyanaz a rés, mint a currentPeriod===2||3 ágban - lásd ott a
                // részletes magyarázatot. after55Count===0 helyett <=1 kell.
                else if (shCount === 2 && after55Count <= 1) icons = ['time-red', 'time', 'time'];
                else if (after55Count === 2) icons = ['time-red', 'time-red', 'time'];
              } else if (totalTimeouts === 3) {
                icons = ['time', 'time', 'time'];
              }
            } else if (currentPeriod === 1) {
              if (fhCount === 1) icons = ['time', 'time-gray', 'time-gray'];
              else if (fhCount === 2) icons = ['time', 'time', 'time-gray'];
              else icons = ['time-gray', 'time-gray', 'time-gray'];
            } else if (currentPeriod === 2 || currentPeriod === 3) {
              if (totalTimeouts === 0) {
                if (fhCount === 0 && isAfter55) icons = ['time-red', 'time-red', 'time-gray'];
                else if (fhCount === 1 && isAfter55) icons = ['time', 'time-red', 'time-gray'];
                else if (fhCount === 0) icons = ['time-red', 'time-gray', 'time-gray'];
                else icons = ['time', 'time-gray', 'time-gray'];
              } else if (totalTimeouts === 1) {
                if (fhCount === 1 && shCount === 0 && isAfter55) icons = ['time', 'time-red', 'time-gray'];
                else if (fhCount === 1 && shCount === 0 && !isAfter55) icons = ['time', 'time-gray', 'time-gray'];
                else if (fhCount === 0 && shCount === 1 && !after55Count) icons = ['time-red', 'time', 'time-gray'];
                else if (after55Count === 1) icons = ['time-red', 'time-red', 'time'];
                else icons = ['time', 'time', 'time-gray'];
              } else if (totalTimeouts === 2) {
                if (fhCount === 2) icons = ['time', 'time', 'time-gray'];
                else if (fhCount === 1 && shCount === 1 && !after55Count) icons = ['time', 'time', 'time-gray'];
                else if (fhCount === 1 && after55Count === 1) icons = ['time', 'time-red', 'time'];
                // JAVÍTÁS: az "after55" időablak a "secondHalf" (shCount) résztartománya
                // (mindkettő seconds<3600, csak az after55 alsó határa szűkebb, 3300), ezért
                // ha a 2 felhasznált időkérésből az egyik pont az utolsó 5 percbe esik,
                // egyszerre igaz shCount===2 ÉS after55Count===1 - ezt korábban egyik ág se
                // fedte le, így minden szürke maradt. Az eredeti "csak after55Count===0" helyett
                // most after55Count<=1 esetén is a helyes (1 piros + 2 zöld) jelölést adja,
                // az after55Count===2 eset (mindkettő az utolsó 5 percben) továbbra is a saját
                // ágán marad, változatlanul.
                else if (shCount === 2 && after55Count <= 1) icons = ['time-red', 'time', 'time'];
                else if (after55Count === 2) icons = ['time-red', 'time-red', 'time'];
              } else if (totalTimeouts === 3) {
                icons = ['time', 'time', 'time'];
              }
            }

            for (let i = 0; i < timeoutDetails.length && i < 3; i++) {
              const slot = icons.findIndex((icon, idx) => icon === 'time' && tooltips[idx] === '-');
              if (slot !== -1) tooltips[slot] = timeoutDetails[i].tooltip;
            }

            return icons.map((icon, i) => ({ icon, tooltip: tooltips[i] }));
          }
          ,
          changePage(value) {
                let self = this;
                let index = value;

                if(self.disabled) {
                    index++;
                }

                let newPath = `/${self.id}/${self.getRoute(index)}`;

                if(self.$route.path !== newPath) {
                    self.$router.push({ path: newPath });
                }
            },
            getRoute(index) {
                let rtn = '';

                this.$router.options.routes.forEach(function (item) {
                    if(!rtn && item['meta'] && (item['meta']['tab'] || item['meta']['tab'] === 0) && item['meta']['tab'] === index) {
                        rtn = item['meta']['slug'];
                    }
                });

                return rtn;
            },
            getStat(team, type, penalty) {
                return this.s.get(this.statistics, team, type, penalty);
            },
            getHalfTimeGoals(team) {
                let rtn = 0;

                if(this.statistics[team] && this.statistics[team]['1']) {
                    rtn = this.statistics[team]['1'].gol + this.statistics[team]['1'].gol7m;
                }

                return rtn;
            },
        },
    }
</script>

<style scoped>
    #header {
        font-family: 'Rubik';
        padding-top: 35px;
    }

    .team-title {
        color: #ffffff;
    }

    .team-header {
        display: flex;
        flex-flow: row;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
    }

    .team-title .col:first-child .team-header {
        padding: 15px 15px 15px 35px;
    }

    .team-title .col:last-child .team-header {
        padding: 15px 35px 15px 15px;
    }

    .team-name {
      font-size: 22px; /* Kicsit kisebb alapméret a biztonság kedvéért (24px helyett) */
      font-weight: bold;
      min-height: 60px; /* Fix magasság helyett minimum magasság */
      width: 100%;

      /* Flexbox a függőleges középhez és a tördeléshez */
      display: flex;
      align-items: center;

      /* Szöveg tördelés engedélyezése */
      white-space: normal;
      line-height: 1.2;
      overflow: hidden;
      word-break: break-word; /* Hosszú szavak tördelése */
    }

    /* Bal oldali igazítás */
    .team-name.left {
      justify-content: flex-start;
      text-align: left;
    }

    /* Jobb oldali igazítás */
    .team-name.right {
      justify-content: flex-end;
      text-align: right;
    }

    /* Mobil nézet javítása */
    @media screen and (max-width: 900px) {
      .team-name {
        font-size: 18px; /* Mobilon még kisebb betűméret */
        min-height: 50px;
        line-height: 1.1;
      }
      /* ... a többi media query marad ... */
    }

    .team-scores {
        display: flex;
        flex-flow: column;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-wrap: nowrap;
        padding-left: 10px;
        padding-right: 10px;
    }

    .sum-score {
        font-size: 30px;
        font-weight: 700;
        line-height: 38px;
    }

    .half-score {
        font-size: 18px;
        font-weight: 500;
        line-height: 22px;
    }

    .logos {
        display: flex;
        flex-flow: row;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
        padding-top: 25px;
        padding-bottom: 25px;
    }

    .team-logo {
        display: flex;
        flex-flow: row;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: nowrap;
        width: 50%;
    }

    .team-logo img {
        max-height: 140px;
        max-width: 140px;
        width: auto;
        height: auto;
    }

    .match-data {
        width: 400px;
        margin-left: -200px;
        margin-right: -200px;
        text-align: center;
        font-size: 18px;
        line-height: 1.44;
        color: #000000;
    }

    .match-time {
        font-weight: bold;
    }

    .match-place {

    }

    .match-competition {
        font-size: 14px;
        font-style: italic;
    }

    .icon-stats {
        margin-bottom: 30px;
    }

    .stat-box {
        display: flex;
        flex-flow: row;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: nowrap;
        width: 50%;
    }

    .stat-box:nth-child(2) {
        flex-flow: row-reverse;
        flex-wrap: nowrap;
    }

    .mini-stat {
        display: flex;
        flex-flow: row;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: nowrap;
        padding-left: 20px;
        padding-right: 20px;
        white-space: nowrap;
        height: 26px;
        font-size: 14px;
        font-weight: bold;
        border-left: 1px solid #000000;
    }

    .stat-box:first-child .mini-stat:first-child {
        border-left: none;
    }
    .stat-box:last-child .mini-stat:last-child {
        border-left: none;
    }

    .mini-stat img {
        margin-right: 7px;
        display: block;
        margin-top: -1px;
    }

    .mini-stat.empty {
        color: #cccccc;
    }

    @media screen and (max-width: 1199px) {
        .mini-stat {
            padding-left: 15px;
            padding-right: 15px;
        }
    }

    @media screen and (max-width: 992px) {
        .stat-box {
            flex-wrap: wrap !important;
            margin: 0 auto;
            max-width: 360px;
        }

        .mini-stat {
            max-width: 110px;
            flex: 1 0 110px;
            border-left: 0;
            padding: 0;
        }

        .mini-stat:nth-child(n+4) {
            margin-top: 10px;
        }

        .match-data {
            width: 260px;
            margin-left: -130px;
            margin-right: -130px;
        }
    }

    @media screen and (max-width: 900px) {
        .team-title {
            margin-top: 0;
        }

        .team-title .col {
            padding: 0;
        }

        .team-title .col:first-child .team-header {
            padding: 10px 0px 10px 10px;
        }

        .team-title .col:last-child .team-header {
            padding: 10px 10px 10px 0px;
        }

        .team-name {
            font-size: 20px;
            line-height: 50px;
        }

        .sum-score {
            font-size: 24px;
            line-height: 30px;
        }

        .half-score {
            font-size: 16px;
            line-height: 20px;
        }

        .logos {
            padding-top: 15px;
            padding-bottom: 15px;
        }
    }

    @media screen and (max-width: 750px) {
        .stat-box {
            max-width: 250px;
        }

        .mini-stat {
            max-width: 110px;
            flex: 1 0 110px;
            border-left: 0;
            font-size: 16px;
        }
    }

    @media screen and (max-width: 640px) {
        .match-data {
            order: -1;
            width: 100%;
            margin-left: 0;
            margin-right: 0;
        }

        .logos {
            flex-wrap: wrap;
        }

        .team-name {
            font-size: 18px;
        }
    }

    @media screen and (max-width: 600px) {
      #header {
        padding-top: 0;
      }
    }

    @media screen and (max-width: 520px) {
        .stat-box {
            max-width: 230px;
        }

        .mini-stat {
            max-width: 100px;
            flex: 1 0 100px;
            border-left: 0;
        }
    }
</style>

<style>
    #main-nav .nav-tabs .nav-item {
        width: 33.334%;
        margin: 0;
    }

    #main-nav .tab-content {
        display: none;
    }

    #main-nav .nav-tabs {
        flex-wrap: nowrap;
    }

    #main-nav .nav-tabs .nav-item .nav-link {
        color: #ffffff;
        font-size: 14px;
        letter-spacing: 1px;
        text-align: center;
        text-transform: uppercase;
        height: 50px;
        display: flex;
        flex-flow: row;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: nowrap;
        border: none;
        border-left: 1px solid #f0f3f6;
        border-radius: 0;
        background-color: #1d252d;
        width: 100%;
        transition: all 300ms;
    }

    #main-nav .nav-tabs .nav-item:first-child .nav-link {
        border-left: none;
        border-top-left-radius: 8px;
    }

    #main-nav .nav-tabs .nav-item:last-child .nav-link {
        border-top-right-radius: 8px;
    }

    #main-nav .nav-tabs .nav-item .nav-link.disabled {
        background-color: #1d252d;
        color: #808080;
    }

    #main-nav .nav-tabs .nav-item .nav-link.active {
        background-color: #23c373;
        color: #ffffff;
    }

    #main-nav .nav-tabs .nav-item .nav-link:not(.disabled):not(.active):hover {
        background-color: #475f69;
    }

    @media screen and (max-width: 750px) {
        #main-nav .nav-tabs {
            flex-wrap: wrap;
        }

        #main-nav .nav-tabs .nav-item {
            width: 100%;
        }

        #main-nav .nav-tabs .nav-item:first-child .nav-link {
            border-top-right-radius: 8px;
        }

        #main-nav .nav-tabs .nav-item:last-child .nav-link {
            border-top-right-radius: 0;
        }

        #main-nav .nav-tabs .nav-item {
            border-bottom: 1px solid #ffffff;
        }

        #main-nav .nav-tabs .nav-item:last-child {
            border-bottom: none;
        }
    }
</style>
